import { renderEdit } from './form';
import { bindInteractions } from './postpone';

export const index = ctx => {
  const id = ctx.params.id;
  if (id && !isNaN(parseInt(id, 10))) {
    // Bind form handling
    renderEdit(id);

    // Enable postpone behavior
    bindInteractions(id);
  }
};



// WEBPACK FOOTER //
// ./src/modules/news/index.js